import Vue from "vue";
import Router from "vue-router";
import Generate from "@/views/Generate";
import Login from "@/views/Login";
import Register from "@/views/Register";
import PageNotFound from "@/views/PageNotFound";
import Users from "@/views/Users";
import License from "@/views/License";
import PreLicense from "@/views/PreLicense";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      alias: "/",
      path: "/generate",
      name: "Generate",
      component: Generate
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { navbar: false }
    },
    {
      path: "/license",
      name: "License",
      component: License
    },
    {
      path: "/licenseFile",
      name: "PreLicense",
      component: PreLicense
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/users",
      name: "Users",
      component: Users
    },
    { path: "*", component: PageNotFound }
  ]
});
